<template>

<div>

    <PageHeader title="Micro Notes" />

    <div class="main-content container-fluid">

      <div class="row">
        <div class="col-md-12">
          <Panel class="panel panel-default panel-border-color panel-border-color-primary">
            <!-- <PanelHeading title="Lecture Note #1" subtitle="Edit a lecture note"></PanelHeading> -->
            <PanelBody>

              <code>#todo - list of micro notes for chapter X? not sure actually let's discuss first. page may not be needed</code>


            </PanelBody>
          </Panel>

        </div><!-- /.col -->
      </div><!-- /.row -->
  </div><!-- /.main-content -->
</div><!-- /.div -->





</template>


<script>
import { mapState, mapActions } from 'vuex'


export default {
  components: {
  },



  mounted() {
    // console.log('initializing summernote')
    // $('#summernote').summernote({
    //   height: 300,                 // set editor height
    //   minHeight: null,             // set minimum height of editor
    //   maxHeight: null,             // set maximum height of editor
    //   focus: true                  // set focus to editable area after initializing summernote
    // });
  },

  //{"email": "bob@example.com", "password": "password", "password\_confirmation": "password"}
  methods: {
  //   createSubject() {
  //     const newSubject = {
  //       title: this.newSubjectTitle,
  //     }
  //     this.$store.dispatch('createSubject', {subject: newSubject}).then(() => {
  //       this.newSubjectTitle = '';
  //     });
  //   },
  //   ...mapActions({
  //     getSubjects: 'getSubjects',
  //   })
  // },
  // computed: {
  //   ...mapState([
  //     'projectShelf',
  //   ])
  },

  data() {
    return {
      text: "Hello World what's going on!",

    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// MicroNoteList.vue?689f75aa